/**
 * dev-ops-aware-admin-api-green
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2024-11-01T00:28:25Z
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * A description of a group of companies used to manage firmware update staging permissions.
 */
export interface CompanyGroup { 
    /**
     * The companies that are currently in the grouping
     */
    companies: Array<number>;
    /**
     * The unix timestamp of when the company was created.
     */
    createdOn: number;
    /**
     * A description of what the company grouping is for.
     */
    description: string;
    /**
     * The unique identifier of the company group
     */
    id: number;
    /**
     * The name of the company group.
     */
    name: string;
}
